// src/store/formSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Interface for CorporationForm data (Step 1)
interface departmentForm {
  name: string;
  email: string;
  contactName: string;
  designation: string;
  agreed: boolean;
  Mailotp: string;
  mobile: string;
  address: string;
  pinCode: string;
  state: string;
  district: string;
  website: string;
  authorityLetter: any | null,

}

interface FormState {
  departmentForm: departmentForm;
}

const initialState: FormState = {
  departmentForm: {
    name: '',
    email: '',
    Mailotp: '',
    mobile: '',
    address: '',
    pinCode: '',
    state: '',
    district: '',
    website: '',
    contactName: '',
    designation: '',
    agreed: false,
    authorityLetter: null,
  },
};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    updateGovernmentForm: (state, action: PayloadAction<Partial<departmentForm>>) => {
      state.departmentForm = { ...state.departmentForm, ...action.payload };
    },
    clearFormData: () => initialState,
  },
});

export const { updateGovernmentForm, clearFormData } = formSlice.actions;
export default formSlice.reducer;